<template>
  <div>
    <div class="mb-8 relative h-24">
      <ValidationProvider
        name="oldPassword"
        rules="required"
        v-slot="{ errors, failedRules }"
      >
        <zt-input
          outlined
          name="oldPassword"
          type="password"
          maxlength="32"
          v-model="value.oldPassword"
          :label="$t('message.loginComponent.passwordExpired.currentPass')"
          :color="errors[0] ? 'danger' : 'primary'"
        />
        <span
          class="text-zt-danger text-sm ml-2"
          v-if="errors[0] && failedRules.required"
        >
          {{ $t('message.loginComponent.passwordExpired.password_validation.required') }}
        </span>
      </ValidationProvider>
    </div>
    <div class="mb-8 relative h-24">
      <ValidationProvider
        name="confirm"
        :rules="{ required: true, min: 8, regex: /^.*[0-9]{1,}.*$/ }"
        v-slot="{ errors, failedRules, invalid }"
      >
        <zt-tooltip
          :position="isMobile ? 'top' : 'left'"
          :clickable="true"
          color="dark-300"
          outlined
          :shadow="true"
        >
          <div slot="body" class="p-3">
            <PasswordPolicies :pass-policies="passwordPolicies" />
          </div>
          <zt-input
            outlined
            name="password"
            type="password"
            maxlength="32"
            v-model="value.password"
            :label="$t('message.loginComponent.passwordExpired.newPass')"
            :color="errors[0] ? 'danger' : 'primary'"
          />
        </zt-tooltip>
        <span
          class="text-zt-danger text-sm ml-2"
          v-if="errors[0] && failedRules.required"
          >{{
            $t(
              'message.loginComponent.passwordExpired.password_validation.required'
            )
          }}
        </span>
        <span
          class="text-zt-danger text-sm ml-2"
          v-if="errors[0] && failedRules.min"
          >{{
            $t(
              'message.loginComponent.passwordExpired.password_validation.min_character_rule'
            )
          }}
        </span>
        <span
          class="text-zt-danger text-sm ml-2"
          v-if="errors[0] && failedRules.regex"
          >{{
            $t(
              'message.loginComponent.passwordExpired.password_validation.min_number_rule'
            )
          }}
        </span>
        <span class="text-zt-md block text-sm ml-2">
          {{
            $t(
              'message.loginComponent.passwordExpired.password_validation.min_character_info'
            )
          }}
        </span>
      </ValidationProvider>
    </div>
    <div class="mb-2 relative h-24">
      <ValidationProvider
        rules="required|password:@confirm"
        v-slot="{ errors, failedRules, invalid }"
      >
        <zt-input
          outlined
          name="rePassword"
          type="password"
          maxlength="32"
          :label="$t('message.loginComponent.passwordExpired.repeatPassword')"
          v-model="value.rePassword"
          :color="errors[0] ? 'danger' : 'primary'"
        />
        <span
          class="text-zt-danger left-0 text-sm ml-2"
          v-if="errors[0] && failedRules.password"
          >{{
            $t(
              'message.loginComponent.passwordExpired.password_validation.no_match_pass'
            )
          }}
        </span>
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
import { useWindowResize } from '@sichern/ui-elements'
import PasswordPolicies from '@/components/generics/passwordPolicies'

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: ''
})

export default {
  name: 'ztAuthPasswordExpiredFields',
  components: {
    PasswordPolicies
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        oldPassword: '',
        password: '',
        rePassword: ''
      })
    },
    passwordPolicies: {
      type: Object,
      default: () => {}
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      isInvalid: null,
      windowSize: useWindowResize(this)
    }
  },

  computed: {
    isMobile() {
      return this.windowSize.width < 1024
    }
  }
}
</script>

<style lang="scss" scoped>
.tooltip-body {
  color: #575757;
  .tooltip-title {
    color: #03a9f4;
  }
}
</style>
